module.exports = __webpack_public_path__ + "media/images/courseware_completion_status_completed-ad709d64c05082ff175aea3cd620adf9.svg";